import { FormOpenMode } from "@multiweb/types/contracts";
import { FormOpenType, MenuType } from "@multiweb/types/multiweb";

/**
 * Převede typ enumu z FormOpenMode na FormOpenType.
 * @param formOpenMode Hodnota k převedení.
 */
export const formOpenModeToFormOpenType = (formOpenMode: FormOpenMode): FormOpenType => {
    switch (formOpenMode) {
        case FormOpenMode.form:
            return FormOpenType.form;
        case FormOpenMode.paramForm:
            return FormOpenType.paramForm;
        case FormOpenMode.paramFormMethod:
            return FormOpenType.paramFormMethod;
        case FormOpenMode.paramFormReport:
            return FormOpenType.paramFormReport;
        case FormOpenMode.paramConditionForm:
            return FormOpenType.paramConditionForm;
    }
};

/**
 * Převede typ enumu z FormOpenType na MenuType. Pro hodnotu FormOpenType.form vrací null.
 * @param formOpenType Hodnota k převedení.
 */
export const formOpenTypeToMenuType = (formOpenType: FormOpenType): MenuType | null => {
    switch (formOpenType) {
        case FormOpenType.paramForm:
            return MenuType.mtForm;
        case FormOpenType.paramFormMethod:
            return MenuType.mtActions;
        case FormOpenType.paramFormReport:
            return MenuType.mtPrint;
        case FormOpenType.paramConditionForm:
            return MenuType.mtConditionForm;
        case FormOpenType.form:
            return null;
    }
};

/**
 * Převede typ enumu z FormOpenMode na MenuType pomocí zkombinování funkcí formOpenModeToFormOpenType a formOpenTypeToMenuType.
 * @param formOpenMode Hodnota k převedení.
 */
export const formOpenModeToMenuType = (formOpenMode: FormOpenMode): MenuType | null => formOpenTypeToMenuType(formOpenModeToFormOpenType(formOpenMode));
